import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { IconButton } from '../button';
import { TextField } from '../textfield';
import { withVersion } from '../utils';
const PasswordFieldImpl = React.forwardRef((props, ref) => {
    const { slotProps, 'data-role': dataRole = 'password-field', ...rest } = props;
    const [visible, setVisible] = React.useState(false);
    const inputSlot = slotProps?.input;
    const existingEndAdornment = inputSlot?.endAdornment;
    const toggle = (_jsx(IconButton, { icon: visible ? 'IconVisibilityOff' : 'IconVisibility', size: "small", onClick: () => setVisible((v) => !v), "aria-label": visible ? 'Hide password' : 'Show password', "data-role": "password-field-visibility-toggle" }, "toggle-password-visibility"));
    return (_jsx(TextField, { ref: ref, type: visible ? 'text' : 'password', "data-role": dataRole, slotProps: {
            ...slotProps,
            input: {
                ...inputSlot,
                endAdornment: (_jsxs(_Fragment, { children: [existingEndAdornment, toggle] }))
            }
        }, ...rest }));
});
PasswordFieldImpl.displayName = 'PasswordField';
export const PasswordField = withVersion(PasswordFieldImpl, '1.0.0');
